import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  BankOutlined,
  TeamOutlined,
  EnvironmentOutlined,
  ArrowRightOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";

import "./jobListingWhoIsHiringNow.scss";
import useNuJobsStore from "../../../store/nujobs.store";

const JobListingWhoIsHiringNow = () => {
const navigate = useNavigate();
const { hiringCompanies,nuJobsEmployerWhoisHiring } = useNuJobsStore();

useEffect(() => {
    // Fetch hiring companies from the store or API
    // This is just a placeholder; replace with actual data fetching logic
    // setHiringCompanies(fetchedCompanies);
    nuJobsEmployerWhoisHiring(0)
  }, []);

  // Replace with backend data later
  const hiringCompanies1 = [
    {
      id: "ORG001",
      name: "ABC Technologies",
      type: "DIRECT",
      location: "Bangalore",
      openJobs: 12,
      hiringFor: "Software, Cloud, DevOps",
      verified: true,
    },
    {
      id: "ORG002",
      name: "Tech Systems India",
      type: "DIRECT",
      location: "Pune",
      openJobs: 8,
      hiringFor: "Embedded, VLSI, Automotive",
      verified: true,
    },
    {
      id: "ORG003",
      name: "Digital Solutions",
      type: "DIRECT",
      location: "Hyderabad",
      openJobs: 6,
      hiringFor: "Java, React, QA",
      verified: true,
    },
    {
      id: "ORG004",
      name: "Talent Consulting",
      type: "CONSULTANCY",
      location: "Bangalore",
      openJobs: 15,
      hiringFor: "IT, Cloud, Data",
      verified: true,
    },
    {
      id: "ORG005",
      name: "Career Staffing",
      type: "CONSULTANCY",
      location: "Pune",
      openJobs: 10,
      hiringFor: "Automotive, Embedded",
      verified: true,
    },
    {
      id: "ORG006",
      name: "People Solutions",
      type: "CONSULTANCY",
      location: "Multiple Locations",
      openJobs: 9,
      hiringFor: "Software, BFSI, Support",
      verified: true,
    },
  ];

  const handleCompanyClick = (company) => {
    // Later you can navigate to jobs filtered by qhoid/company ID
    navigate(`/nujobswhoishiringnowcompany/company/${company.id}`);
  };

  const handleViewAll = () => {
    navigate("/nujobswhoishiringnow");
  };

  return (
    <section className="nujobs-home-hiring">

      {/* HEADER */}    
      <div className="nujobs-home-hiring-header">

        <div className="nujobs-home-hiring-title">
          <TeamOutlined />

          <div>
            <p>
              Explore employers and recruitment partners actively hiring
              on NuJobs.
            </p>
          </div>
        </div>

        <button
          className="hiring-view-all"
          onClick={handleViewAll}
        >
          View All
          <ArrowRightOutlined />
        </button>

      </div>

      {/* CARDS */}
      <div className="nujobs-home-hiring-grid">

        {hiringCompanies.slice(0, 6).map((company) => (

          <div
            className="nujobs-home-hiring-card"
            key={company.id}
            onClick={() => handleCompanyClick(company)}
          >

            {/* TOP */}
            <div className="hiring-card-top">

              <div className="company-icon">
                <BankOutlined />
              </div>

              <span
                className={`company-type ${
                  company.type === "DIRECT"
                    ? "direct"
                    : "consultancy"
                }`}
              >
                {company.type === "DIRECT"
                  ? "Direct Employer"
                  : "Recruitment Partner"}
              </span>

            </div>

            {/* COMPANY */}
            <div className="hiring-company-name">

              <h3>{company.name}</h3>

              {company.verified && (
                <span
                  className="verified"
                  title="Verified on NuJobs"
                >
                  <SafetyCertificateOutlined />
                </span>
              )}

            </div>

            {/* LOCATION */}
            <div className="hiring-location">
              <EnvironmentOutlined />
              <span>{company.location}</span>
            </div>

            {/* HIRING FOR */}
            <div className="hiring-for">

              <span className="label">
                Hiring For
              </span>

              <p>{company.hiringFor?.toUpperCase()}</p>

            </div>

            {/* FOOTER */}
            <div className="hiring-card-footer">

              <span className="open-jobs">
                <strong>{company.openJobs}</strong> Open Jobs
              </span>

              <span className="view-jobs">
                View Company
                <ArrowRightOutlined />
              </span>

            </div>

          </div>

        ))}

      </div>

      {/* MOBILE VIEW ALL */}
      <button
        className="hiring-view-all-mobile"
        onClick={handleViewAll}
      >
        View All Hiring Companies
        <ArrowRightOutlined />
      </button>

    </section>
  );
};

export default JobListingWhoIsHiringNow;